// don't use relative URLs in test env so we can use nock lib.
export const API_HOST = process.env.API_HOST || '';

export const parseResponseJson = response => {
  if (!response.ok) throw new Error();
  return response.json();
};

export const getFilmIdParams = filmIds => {
  const paramName = encodeURIComponent('film_ids[]');
  return filmIds.map(filmId => `${paramName}=${filmId}`).join('&');
};

const fetchConfig = (method = 'GET', body) => {
  const config = {
    method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      client: 'web',
    },
    credentials: 'same-origin',
  };
  const csrfElem = document.querySelector('meta[name="csrf-token"]');
  if (csrfElem) config.headers['X-CSRF-Token'] = csrfElem.getAttribute('content');
  if (body) config.body = JSON.stringify(body);
  return config;
};

export default fetchConfig;
